<template>
<div>
    <section class="section_logo-bar">
        <div class="logonav_wrap">
            <div class="logonav_div">
                <a href="#" class="link-block-73 w-inline-block"><img sizes="(max-width: 3696px) 100vw, 3696px" srcset="@/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-500.png 500w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-800.png 800w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-1080.png 1080w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-1600.png 1600w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-2000.png 2000w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-2600.png 2600w, @/assets/images/5218368d1c171d1d821ad3c1dad1239f_OhMyMeds_Logo-p-3200.png 3200w, @/assets/images/OhMyMeds_Logo.png 3696w" alt="" src="@/assets/images/OhMyMeds_Logo.png" loading="lazy" class="image-487"></a>
            </div>
        </div>
    </section>
    <section class="orig-backup">
        <div class="report-wrap">
            <div class="report-div">
                <div class="report-body-main-div">
                    <div class="top-section-div">
                        <div class="text-block-1105"><span class="text-span-239">Congrats {{ user.first_name }}! </span><br>You meet the initial pre-qualifications.<br>You are all set to <strong>lose {{ user.weight - desiredWeight }} Pounds!</strong></div>
                    </div>
                    <div class="report-summary-div-2">
                        <div class="div-block-1534">
                            <div class="div-block-1537">
                                <div class="text-block-575">{{ user.first_name }}&#x27;s <strong>Medical Weight Loss Plan</strong></div>
                            </div>
                            <div class="div-block-1535">
                                <div class="div-block-1536">
                                    <div class="text-block-573 _1">Your Current Weight </div>
                                    <div class="text-block-574">{{ user.weight }} <span class="text-span-107">lbs</span></div>
                                </div>
                                <div class="div-block-1536">
                                    <div class="text-block-573">Your Target Weight is</div>
                                    <div class="text-block-574">{{ desiredWeight }} <span class="text-span-107">lbs</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="div-block-1923">
                            <div class="div-block-1921">
                                <div class="text-block-1104">Average Weight Loss On Semaglutide</div>
                                <div class="div-block-1922"></div>
                                <div class="div-block-1535">
                                    <div class="div-block-1924">
                                        <div class="text-block-1119">Fad Diet</div>
                                        <div class="text-block-1106">-5<sup>%</sup></div>
                                    </div>
                                    <div class="div-block-1918">
                                        <div class="text-block-1116">With Semaglutide</div>
                                        <div class="text-block-1121">-16<sup>%</sup></div>
                                    </div>
                                    <div class="div-block-1925">
                                        <div class="text-block-1108">Your Current Weight</div>
                                        <div class="text-block-1123">{{ user.weight }} lbs</div>
                                        <div class="div-block-1935 _1">
                                            <div class="text-block-1108">Weight you Can Lose</div>
                                            <div class="text-block-1123">{{ (parseInt(user.weight) * 0.16).toFixed(0) }} lbs</div>
                                        </div>
                                        <div class="div-block-1935 _2">
                                            <div class="text-block-1108">Your New Weight</div>
                                            <div class="text-block-1123">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.16)).toFixed(0) }} lbs</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-block-1917">
                                <div class="div-block-1932"><img loading="lazy" src="@/assets/images/Report_Chart_Montserrat.svg" alt="" class="image-503"></div>
                            </div>
                            <div class="div-block-1919 small">
                                <div class="text-block-1104 small">1 in 3 Lose 23% of Body Weight</div>
                                <div class="div-block-1922"></div>
                                <div class="div-block-1938">
                                    <div class="div-block-1929">
                                        <div class="text-block-1118 small">Weight you could Lose</div>
                                    </div>
                                    <div class="div-block-1927">
                                        <div class="text-block-1117 small">{{ (parseInt(user.weight) * 0.23).toFixed(0) }}</div>
                                        <div class="text-block-1114 small">lbs.</div>
                                    </div>
                                    <div>
                                        <div class="text-block-1107 small">Your New Weight</div>
                                        <div class="text-block-1112 small">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.23)).toFixed(0) }} lbs.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-block-1919 small">
                                <div class="text-block-1104 small">People on OhMyMeds&#x27;s 30-day Challenge</div>
                                <div class="div-block-1922"></div>
                                <div class="div-block-1938">
                                    <div class="div-block-1929">
                                        <div class="text-block-1118 small">Weight you could Lose</div>
                                    </div>
                                    <div class="div-block-1927">
                                        <div class="text-block-1117 small">{{ (parseInt(user.weight) * 0.28).toFixed(0) }}</div>
                                        <div class="text-block-1114 small">lbs.</div>
                                    </div>
                                    <div>
                                        <div class="text-block-1107 small">Your New Weight</div>
                                        <div class="text-block-1112 small">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.28)).toFixed(0) }} lbs.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="div-block-1527"></div>
                        <div class="div-block-1624">
                            <div class="reportbox">
                                <div class="table-row-div top">
                                    <div class="div-block-1603"></div>
                                    <div class="div-block-1604">
                                        <div class="text-block-655 top">% Loss</div>
                                    </div>
                                    <div class="div-block-1614">
                                        <div class="text-block-655 top">Weight Loss</div>
                                    </div>
                                    <div class="div-block-1636">
                                        <div class="text-block-655 top">New Weight</div>
                                    </div>
                                </div>
                                <div class="table-row-div">
                                    <div class="div-block-1603">
                                        <div class="text-block-655">Avg. Weight Loss on <span class="text-span-241">Semaglutide</span></div>
                                    </div>
                                    <div class="div-block-1604">
                                        <div class="text-block-637">16%</div>
                                    </div>
                                    <div class="div-block-1614">
                                        <div class="text-block-637">{{ (parseInt(user.weight) * 0.16).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                                    </div>
                                    <div class="div-block-1636">
                                        <div class="text-block-637">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.16)).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                                    </div>
                                </div>
                                <div class="table-row-div">
                                    <div class="div-block-1603">
                                        <div class="text-block-655">1 in 3 lose more on <span class="text-span-241">Semaglutide</span><br></div>
                                    </div>
                                    <div class="div-block-1604">
                                        <div class="text-block-637">23%</div>
                                    </div>
                                    <div class="div-block-1614">
                                        <div class="text-block-637">{{ (parseInt(user.weight) * 0.23).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                                    </div>
                                    <div class="div-block-1636">
                                        <div class="text-block-637">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.23)).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                                    </div>
                                </div>
                                <div class="table-row-div">
                                    <div class="div-block-1603">
                                        <div class="text-block-655">Avg. Weight Loss on <span class="text-span-241">Tirzepatide</span><br></div>
                                    </div>
                                    <div class="div-block-1604">
                                        <div class="text-block-637">23%</div>
                                    </div>
                                    <div class="div-block-1614">
                                        <div class="text-block-637">{{ (parseInt(user.weight) * 0.23).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                                    </div>
                                    <div class="div-block-1636">
                                        <div class="text-block-637">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.23)).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                                    </div>
                                </div>
                                <div class="table-row-div bottom">
                                    <div class="div-block-1603">
                                        <div class="text-block-655">1 in 3 lose more on <span class="text-span-241">Tirzepatide</span></div>
                                    </div>
                                    <div class="div-block-1604">
                                        <div class="text-block-637">28%</div>
                                    </div>
                                    <div class="div-block-1614">
                                        <div class="text-block-637">{{ (parseInt(user.weight) * 0.28).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                                    </div>
                                    <div class="div-block-1636">
                                        <div class="text-block-637">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.28)).toFixed(0) }} <span class="text-span-144">lbs</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="next-steps-div">
                        <div class="next-steps-box">
                            <div class="next-step-header-div">
                                <div class="text-block-1113">What&#x27;s Next?</div>
                                <div class="text-block-1110">You are about to join thousands losing weight with Semaglutide &amp; Tirzepatide.</div>
                            </div>
                            <div class="step-entry-div">
                                <div class="next-iimgdiv"><img loading="lazy" src="@/assets/images/OhMy_VialUpdate_Tirzep.png" alt="" class="image-498"></div>
                                <div class="div-block-1937">
                                    <div class="text-block-1124">Select Your Prescription</div>
                                    <div class="text-block-1103">You&#x27;ll choose between Semaglutide &amp; Tirzepatide on the next page.</div>
                                </div>
                            </div>
                            <div class="step-entry-div">
                                <div class="next-iimgdiv"><img loading="lazy" src="@/assets/images/icon_card.png" alt="" class="image-500"></div>
                                <div class="div-block-1937">
                                    <div class="text-block-1124">Pre-Authorize Your Card</div>
                                    <div class="text-block-1103">These medications are in high demand. We will need to pre-authorize your card today to secure your medication and telemed appointment. (Funds are held until shipment. If denied, funds will be released back to you.)</div>
                                </div>
                            </div>
                            <div class="step-entry-div">
                                <div class="next-iimgdiv"><img loading="lazy" src="https://cdn.prod.website-files.com/668d55c8f0b55e9fc41fd2b8/66c64417ab952fc218b77121_icon_clipboard.png" alt="" class="image-497"></div>
                                <div class="div-block-1937">
                                    <div class="text-block-1124">Complete The Medical Intake</div>
                                    <div class="text-block-1103">Once your payment is made, we will send you an email with instructions on how to access your Direct Meds patient portal and complete a few medical questions for the doctor.</div>
                                </div>
                            </div>
                            <div class="step-entry-div">
                                <div class="next-iimgdiv"><img loading="lazy" src="@/assets/images/icon_docpicCare.png" alt="" class="image-502"></div>
                                <div class="div-block-1937">
                                    <div class="text-block-1124">Doctor&#x27;s Review</div>
                                    <div class="text-block-1103">The doctor will review your chart. (Usually within 5 hours including weekends.)</div>
                                </div>
                            </div>
                            <div class="step-entry-div last">
                                <div class="next-iimgdiv"><img loading="lazy" src="https://cdn.prod.website-files.com/668d55c8f0b55e9fc41fd2b8/66c742632bf62043d3fad823_icon_van.png" alt=""></div>
                                <div class="div-block-1937">
                                    <div class="text-block-1124">Approval and Shipping</div>
                                    <div class="text-block-1103">Once approved, our FDA-registered pharmacy will ship your ice-packed medication with UPS next-day rush delivery. Orders ship same day, except Fridays. A tracking number will be provided to your email address when your medication ships.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="testimonial-div">
                        <div class="pics-div">
                            <div class="pic-div"><img src="@/assets/images/ba_2b.png" loading="lazy" alt=""></div>
                            <div class="pic-div"><img src="@/assets/images/ba_2a.png" loading="lazy" alt=""></div>
                        </div>
                        <div class="div-block-1623"><img loading="lazy" src="@/assets/images/icon_stars.svg" alt="" class="image-351">
                            <div class="text-block-657">I feel lighter both physically and emotionally.</div>
                            <p class="paragraph-119">For the first time in years, I feel in control of my health. I have more energy, improved sleep, and everyday activities are much easier. It truly feels like a new chapter in my life.<br></p>
                            <div class="text-block-636"><strong>Lana R, Lost 58 lbs</strong></div>
                        </div>
                    </div>
                    <div class="huge-savings-div">
                        <div class="div-block-1633">
                            <div class="text-block-672">Get HUGE Savings <span class="text-span-153">PLUS <sup>$</sup>100 off!</span></div>
                        </div>
                        <div class="div-block-1621">
                            <div class="summary-entry-2 top">
                                <div class="div-block-1625 top"><img loading="lazy" src="@/assets/images/OhMy_Vial_TIRZ.png" alt="" class="image-348 report">
                                    <div class="item-detail _1 top">
                                        <div class="text-block-664 report top">All Dosages the Same Low Price</div>
                                        <div class="text-block-652 report">We do not charge you double like competitors when you increase your dosage in the next 3 months.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="summary-entry-2">
                                <div class="div-block-1625"><img loading="lazy" src="@/assets/images/icon_docpic2.png" alt="" class="image-348 report">
                                    <div class="text-block-664 report">Doctor Support<br>and Monitoring</div>
                                </div>
                                <div class="item-price">
                                    <div class="no-discount-price step-2 report"><sup>$</sup>99</div>
                                    <div class="text-block-648 report">Free</div>
                                </div>
                            </div>
                            <div class="summary-entry-2">
                                <div class="div-block-1625"><img loading="lazy" src="@/assets/images/icon_docpicCare.png" alt="" class="image-348 report">
                                    <div class="text-block-664 report">Metabolic testing and<br>blood work included</div>
                                </div>
                                <div class="item-price">
                                    <div class="no-discount-price step-2 report"><sup>$</sup>75</div>
                                    <div class="text-block-648 report">Free</div>
                                </div>
                            </div>
                            <div class="summary-entry-2">
                                <div class="div-block-1625"><img loading="lazy" src="https://uploads-ssl.webflow.com/66ac7d81f3eb9a615c96a5be/66cc60cbb0429414efa33512_icon_van.png" alt="" class="image-348 report van">
                                    <div class="text-block-664 report">Overnight Shipping</div>
                                </div>
                                <div class="item-price">
                                    <div class="no-discount-price step-2 report"><sup>$</sup>40</div>
                                    <div class="text-block-648 report">Free</div>
                                </div>
                            </div>
                            <div class="savings-div-2"><img loading="lazy" src="@/assets/images/party-popper.png" alt="" class="image-347">
                                <div class="text-block-651 report">You saved <sup>$</sup>314 on your order!</div>
                            </div>
                        </div>
                    </div>
                    <div class="testimonial-div">
                        <div class="pics-div">
                            <div class="pic-div"><img src="@/assets/images/ba_4b.png" loading="lazy" alt=""></div>
                            <div class="pic-div"><img src="@/assets/images/ba_4a.png" loading="lazy" alt=""></div>
                        </div>
                        <div class="div-block-1623"><img loading="lazy" src="@/assets/images/icon_stars.svg" alt="" class="image-351">
                            <div class="text-block-657">Oh My Meds helped me achieve weight goals I never thought possible.</div>
                            <p class="paragraph-119">Losing weight has given me freedom I didn't think I'd ever have again. I can go hiking with friends, and enjoy life without the constant fatigue and self-doubt that used to weigh me down.</p>
                            <div class="text-block-636"><strong>Ashley D</strong>, lost 65 lbs.</div>
                        </div>
                    </div>
                    <div class="expectations-div">
                        <div class="text-block-1109">What You can Expect</div>
                        <p class="paragraph-150">Join the millions of Americans losing weight with Semaglutide and <strong>start seeing results in as little as 4 weeks!</strong></p>
                        <div class="div-block-1936">
                            <div class="div-block-1928">
                                <div class="div-block-1931">
                                    <div class="text-block-1115">Lose weight</div>
                                    <div class="text-block-1125">On average, Semaglutide users <span class="text-span-237">lose around 16%</span> of their body weight</div>
                                </div>
                                <div class="div-block-1931">
                                    <div class="text-block-1115">Feel fuller, longer</div>
                                    <div class="text-block-1125">Semaglutide <span class="text-span-237">suppresses appetite</span> and curbs food cravings**</div>
                                </div>
                            </div>
                            <div class="div-block-1928">
                                <div class="div-block-1931">
                                    <div class="text-block-1115">Reduce cholesterol</div>
                                    <div class="text-block-1125">Semaglutide has been shown to <span class="text-span-237">reduce total cholesterol, </span> LDL cholesterol &amp; triglycerides**</div>
                                </div>
                                <div class="div-block-1931">
                                    <div class="text-block-1115">Improve heart health</div>
                                    <div class="text-block-1125"><span class="text-span-237">Prevent heart attacks</span> and reduce the risk of major cardiac events***</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="issues_div">
                        <div class="issues_header"><strong class="bold-text">Weight struggles can take away life's simple pleasures</strong></div>
                        <div class="issues_flex">
                            <div class="issues_half-div">
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Persistent fatigue</div><img loading="lazy" src="@/assets/images/IconSet_batt_1IconSet_batt.png" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Emotional stress</div><img loading="lazy" src="@/assets/images/IconSet_heart_1IconSet_heart.png" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Increased appetite</div><img loading="lazy" src="@/assets/images/IconSet_mind_1IconSet_mind.png" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Compromised mobility</div><img loading="lazy" src="@/assets/images/IconSet_exercise_1IconSet_exercise.png" alt="" class="image-482">
                                </div>
                                <div class="issues_line mob"></div>
                                <div class="issues_line"></div>
                            </div>
                            <div class="issues_half-div">
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Low mood/anxiety</div><img loading="lazy" src="@/assets/images/IconSet_anxiety_1IconSet_anxiety.png" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Difficulty with weight regulation</div><img loading="lazy" src="@/assets/images/IconSet_scale_1IconSet_scale.png" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Low self-esteem</div><img loading="lazy" src="@/assets/images/IconSet_mood_1IconSet_mood.png" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Sleep disturbances</div><img loading="lazy" src="@/assets/images/IconSet_Sleep_1IconSet_Sleep.png" alt="" class="image-482">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="report-div-container"></div>
        <div class="reportstickybuttondiv">
            <div class="reportbutton_container">
                <router-link to="/select-med" class="link-block-41 w-inline-block">
                    <div class="text-block-665">Click Here to Start your FREE <br>Medical Weight Loss Evaluation <span class="text-span-154">-&gt;</span></div>
                </router-link>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';

export default {
    data() {
        return {
            desiredWeight: 120
        };
    },
    computed: {
        ...mapGetters([
            'user',
        ])
    },
    mounted() {
        if(this.$route.query.desiredWeight){
            this.desiredWeight = this.$route.query.desiredWeight;
        }
    }
};
</script>